/* eslint-disable camelcase */
import { List, ListItem, Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';
import { FinleyValleyBankResponseTapeRow } from '@finley-technologies/valley-bank-utils';

import { ArrangementGroupSummaryLink } from 'valleyBank/domains/ArrangementGroups/hooks/ArrangementGroupsContext';

export const getArrangementGroupNumbers = (
  receivables: FinleyValleyBankResponseTapeRow[],
): string[] => {
  const arrangementGroups = new Set(
    receivables.map(({ arrangement_group }) => arrangement_group),
  );

  const arrangementGroupsArray = _.compact(Array.from(arrangementGroups));

  return arrangementGroupsArray;
};

export const CollateralAccountArrangementGroupNumbers: React.FC<{
  receivables: FinleyValleyBankResponseTapeRow[];
  arrangementGroupOverride?: Util.Maybe<string>;
}> = ({ receivables, arrangementGroupOverride }) => {
  const arrangementGroups = getArrangementGroupNumbers(receivables);

  if (arrangementGroups.length === 0 && !arrangementGroupOverride) {
    return <Text>-</Text>;
  }

  // will take the arrangement group number of the parent if available
  if (arrangementGroups.length === 0 && arrangementGroupOverride) {
    return (
      <ArrangementGroupSummaryLink arrangementGroup={arrangementGroupOverride}>
        {arrangementGroupOverride}
      </ArrangementGroupSummaryLink>
    );
  }

  return (
    <List>
      {Array.from(arrangementGroups).map((arrangementGroupNumber) => {
        return (
          <ListItem key={arrangementGroupNumber}>
            <ArrangementGroupSummaryLink
              arrangementGroup={arrangementGroupNumber || ''}
            >
              {arrangementGroupNumber || '-'}
            </ArrangementGroupSummaryLink>
          </ListItem>
        );
      })}
    </List>
  );
};
